var map = {
	"./AVA.png": 8424,
	"./AVA_2.png": 6059,
	"./Voyage_Global_svg_Blue.svg": 5993,
	"./Voyage_Global_svg_White.svg": 2376,
	"./Voyage_Global_svg_free1-01.png": 5694,
	"./Voyage_Global_svg_free2-01.png": 71,
	"./Voyage_Global_svg_gold-01.svg": 3521,
	"./bg-5.png": 3675,
	"./bg-mob.jpg": 7728,
	"./ceo.jpg": 5877,
	"./des.jpg": 4914,
	"./email.svg": 4426,
	"./instagram.png": 6750,
	"./location.svg": 9915,
	"./manager1.jpg": 526,
	"./manager2.jpg": 1289,
	"./manager3.jpg": 6588,
	"./manager4.jpg": 2583,
	"./news/a1.jpg": 8732,
	"./news/a2.jpg": 5179,
	"./news/a3.jpg": 5022,
	"./news/ab1.jpg": 5782,
	"./news/ab2.jpg": 7921,
	"./news/ab3.jpg": 7972,
	"./news/fuk1.jpg": 7585,
	"./news/fuku1.jpg": 6532,
	"./news/fuku2.jpg": 8339,
	"./news/fuku3.jpg": 7286,
	"./news/hn1.jpg": 3043,
	"./news/hn2.jpg": 1412,
	"./news/hn3.jpg": 9457,
	"./news/hn4.jpg": 1442,
	"./news/hn5.jpg": 5727,
	"./news/kat1.jpg": 4947,
	"./news/kat2.jpg": 8884,
	"./news/kat3.jpg": 689,
	"./news/sh1.jpg": 1698,
	"./news/sh2.jpg": 925,
	"./news/sh3.jpg": 6032,
	"./news/top1.jpg": 6768,
	"./news/top2.jpg": 1103,
	"./news/top3.jpg": 8434,
	"./news/tr1.jpg": 8715,
	"./news/tr2.jpg": 1020,
	"./news/tr3.jpg": 4745,
	"./news/viet1.jpg": 7845,
	"./news/viet2.jpg": 3706,
	"./news/viet3.jpg": 9511,
	"./office/1.jpg": 3112,
	"./office/2.jpg": 1783,
	"./office/3.jpg": 9850,
	"./office/4.jpg": 9337,
	"./pay-logo.png": 2502,
	"./phone.svg": 8382,
	"./rata.jpg": 7210,
	"./rata_member.svg": 5637,
	"./svid.jpg": 2776,
	"./telegram.png": 4509,
	"./viber.png": 1244,
	"./yes.svg": 6151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;